import React from "react";
import "./Benefit.scss";
import Helpers from "@utils/Helpers";
import credit from "@assets/img/credit-card.png";

const Benefit: React.FC = () => {
  return (
    <div className="Benefit-section">
      <div className="section-title">Benefits</div>
      <div className="container">
        <div className="row">
          <div className="col-lg-3 col-md-6 col-sm-12">
            <div className="benefit-item benefit-item-1">
              <img
                src={Helpers.getImageFrontPage("benefit1")}
                className="img-fluid"
                alt="Benefit 1"
              />
              <div className="benefit-item-title">Accessing a wider market</div>
              <div className="benefit-item-description">
                Buyers can quickly and easily source high-quality, farm-fresh
                products from producers around the globe through our platform.
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-12">
            <div className="benefit-item benefit-item-2">
              <img
                src={Helpers.getImageFrontPage("benefit2")}
                className="img-fluid"
                alt="Benefit 2"
              />
              <div className="benefit-item-title">
                Eliminating intermediaries
              </div>
              <div className="benefit-item-description">
                Producers and consumers can bypass traditional supply chains,
                reducing costs and keeping more of the profit for themselves, by
                providing a platform where they can directly engage with each
                other and negotiate pricing.
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-12">
            <div className="benefit-item benefit-item-3">
              <img
                src={Helpers.getImageFrontPage("benefit3")}
                className="img-fluid"
                alt="Benefit 3"
              />
              <div className="benefit-item-title">Valuable market insights</div>
              <div className="benefit-item-description">
                Leveraging automated data analysis to provide producers with
                insights into consumer preferences, market trends, and pricing
                information, enabling them to make data-driven decisions.
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-12">
            <div className="benefit-item benefit-item-4">
              <img
                src={credit}
                className="img-fluid"
                alt="Benefit 4"
                width={"92px"}
              />
              <div className="benefit-item-title">Credit card payment</div>
              <div className="benefit-item-description">
                Both the seller and buyer can enjoy all the benefits that come with paying and receiving a credit card payment.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Benefit;
